module.exports = __webpack_public_path__ + "img/elegir.7ab91e87.png";